import { render, staticRenderFns } from "./CardIncome.vue?vue&type=template&id=2645ae32"
import script from "./CardIncome.vue?vue&type=script&lang=js"
export * from "./CardIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports